import React, { useEffect } from 'react';
import {
  CButton,
  CForm,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter, CLabel, CInput, CFormGroup,
} from '@coreui/react';
import { FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import classNames from 'classnames';
import { get } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Organization } from '../../models/organization';
import LoadingButton from '../LoadingButton';
import {
  selectOrgHierarchyCreatedState,
  selectOrgHierarchyCreatingState,
} from '../../../store/selectors/orgHierarchy.selectors';
import { CreateNewOrg } from '../../../store/actions/orgHierarchy.action';
import renderError from '../../utils/error-utils';

const validationSchema = Yup.object({
  name: Yup.string().required('Org name is required'),
});

const initialValues = {
  name: '',
};

export interface CreateOrgModalProps {
  show: boolean;
  onClose: () => void;
  parent: Organization;
}

const CreateOrgModal = (props: CreateOrgModalProps) => {
  const {
    show,
    onClose,
    parent
  } = props;

  const saving = useSelector(selectOrgHierarchyCreatingState);
  const saved = useSelector(selectOrgHierarchyCreatedState);
  const dispatch = useDispatch();

  const onSubmit = (values: any) => {
    dispatch(new CreateNewOrg({
      name: values.name,
      parentId: parent._id,
      adminEmail: parent.admin_email,
      tags: ['no-billing', 'view:list'],
    }));
  };

  const formik = useFormik({
      initialValues,
      validationSchema,
      onSubmit,
    },
  );

  useEffect(() => {
    if (saved) {
      onClose();

      formik.resetForm();
    }
  }, [saved]);

  const handleClose = () => {
    onClose();
    formik.resetForm();
  };

  const isInvalid = (fieldName: string) => get(formik.touched, fieldName) && get(formik.errors, fieldName);

  return (
    show && <CModal className="mt-5 pt-5" id="add-job-modal" show={ show } onClose={ handleClose } closeOnBackdrop={ false }>
      <CModalHeader closeButton>Create an Organization</CModalHeader>
      <CForm onSubmit={ formik.handleSubmit }>
        <FormikProvider value={formik}>
          <CModalBody>
            <CFormGroup>
              <CLabel htmlFor="name">Organization Name</CLabel>
              <CInput
                id="name"
                type="text"
                placeholder="Organization Name"
                name="name"
                className={classNames({'is-invalid': isInvalid('name')})}
                { ...formik.getFieldProps('name') }
              />
              {isInvalid('name') && <div className="invalid-feedback">{ renderError(formik.errors.name) }</div>}
            </CFormGroup>
          </CModalBody>
          <CModalFooter className="glympse-footer">
            <div className="glympse-btnWrapper">
              <LoadingButton color='primary' className='bg-color-orange pl-5 pr-5 border-0 roundedBtn roundBottomShadow' type='submit' isLoading={ saving }>Create</LoadingButton>
            </div>
            <div className="glympse-btnWrapper">
              <CButton className="glympse-cancelBtn" color="light" shape="rounded-pill" variant="ghost" onClick={ handleClose }>Cancel</CButton>
            </div>
          </CModalFooter>
        </FormikProvider>
      </CForm>
    </CModal>
  );
};

export default CreateOrgModal;
